import { notification } from '@hem/ui'
import { getEnvVariable } from '@hem/utils'
import axios from 'axios'
import { getCookie } from 'cookies-next'

export const getAxios = () => {
  const env = getEnvVariable()

  const accessToken = getCookie('user')
  if (!accessToken) {
    notification.error({ message: 'Access denied! Please login again!' })
    window.location.replace(`${env.origin}/login`)
  }

  return axios.create({
    baseURL: env.baseURL,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })
}

export const getAxiosV2 = () => {
  const env = getEnvVariable()

  const accessToken = getCookie('user')
  if (!accessToken) {
    notification.error({ message: 'Access denied! Please login again!' })
    window.location.replace(`${env.origin}/login`)
  }

  return axios.create({
    baseURL: env.baseURL.replace('/v1', '/v2'),
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  })
}
